import React, { useEffect, useState } from "react";
import { postMessage } from "../services/api";
import { validateMobile } from "../utils/chatUtils";
import { toast } from "react-toastify";

import ChatSidebar from "../components/CommonComponents/ChatSidebar";
import ChatHeader from "../components/CommonComponents/ChatHeader";
import Disclaimer from "../components/CommonComponents/Disclaimer";
import LoaderPage from "../components/CommonComponents/Loader/LoaderPage";

import "../images/css/contact.css"

const ContactUs: React.FC = () => {
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [loader, setLoader] = useState<boolean>(false);
  const req = `<span style="color: red">*</span>`

  useEffect(() => {
    document.title = "AskWellie | Contact Us";
  }, []);


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const mobileRes = validateMobile(mobile)

    if (mobileRes) {
      setLoader(true);
      try {
        const response = await postMessage("/api/contact-us", { name, email, mobile, message }, false);
        if (response.success) {
          toast.success(response.msg, { position: "top-right", autoClose: 1000 });
          setName("");
          setEmail("");
          setMessage("");
          setMobile("");
        }
        else {
          toast.error(response.msg, { position: "top-right", autoClose: 3000 });
        }
      }
      catch (error) {
        toast.error("An error occurred while sending the message.", { position: "top-right", autoClose: 3000 });
      }
      finally {
        setLoader(false);
      }
    }
  };


  return (
    <div>
      <ChatHeader />
      <div className="chat-row-container flex-columns columns-full">
        <ChatSidebar />

        <>
          <div className="chat-row-container flex-columns columns-full">
            <div className="max-w-4xl mx-auto p-6 right-content-wrapper h-100dvh contact-wrapper">
              <div className="chat-title"><h1>Contact Us</h1></div>
              <div className="cms-wrapper">
                <div className="cms-wrapper-inner h-cal">
                  {loader ? (
                    <LoaderPage />
                  ) : (

                    <form onSubmit={handleSubmit} className="contact-form">
                      <div>
                        <label>Name<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="text"
                          placeholder="Enter Your Name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required />
                      </div>
                      <div>
                        <label>Email<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="email"
                          placeholder="Enter Your Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required />
                      </div>

                      <div>
                        <label>Mobile<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <input
                          type="text"
                          placeholder="Enter Your Mobile"
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                          required />
                      </div>

                      <div>
                        <label>Message<span dangerouslySetInnerHTML={{ __html: req }} /></label>
                        <textarea
                          placeholder="Enter Your Message"
                          value={message}
                          onChange={(e) => {
                            const inputValue = e.target.value;

                            if (inputValue.length > 255) {
                              toast.warning(`Message cannot exceed 255 characters!`, { position: "top-right", autoClose: 3000 });
                              return;
                            }
                            setMessage(inputValue);
                          }}
                          rows={6}
                          required
                        />
                        <small>{message.length}/255</small>

                      </div>
                      <div className="form-submit">
                        <button type="submit">Send Message</button>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      </div>
      <Disclaimer />
    </div>
  );
};


export default ContactUs;
